export default __webpack_public_path__ + "static/feature3-37ae546401591b72a0db510f8b5f2294.png";